import { type FC } from 'react';

import styles from './BannerSkeleton.css';

/**
 * Заглушка-скелетон, которая перекрывает область баннера, пока он грузится.
 */
export const BannerSkeleton: FC = () => {
  // Пока нет дизайна скелетона, возвращаем null
  return null;

  return (
    <div className={styles['skeleton']} aria-hidden="true">
      <div className={styles['wrapper']}>
        <div className={styles['preview']} />
        <div className={styles['content']}>
          <div className={styles['line']} />
          <div className={styles['line']} />
        </div>
      </div>
    </div>
  );
};
